import React from "react";
import { NavLink } from "react-router-dom";
import { aemInvalidateCache } from "../../../services";

interface NavListProps {
    title: string;
    navList: Nav[];
    backUrl?: string;
    invalidateCache?: boolean;
}

interface Nav {
    name: string;
    url: string;
}

function NavList(props: NavListProps) {
    const { title, navList, backUrl, invalidateCache } = props;

    return (
        <>
            {backUrl && (
                <NavLink className="text-white" to={backUrl}>
                    <button className="btn btn-outline-primary">Back</button>
                </NavLink>
            )}
            <div className={`list-group ${backUrl ? "mt-5" : ""}`}>
                <div className="list-group-item list-group-item-action bg-light">{title}</div>

                {navList.map((item, index) => (
                    <NavLink
                        key={`${item.name}-${index}`}
                        className="list-group-item list-group-item-action"
                        to={item.url}
                    >
                        {item.name}
                    </NavLink>
                ))}

                {invalidateCache && (
                    <button
                        className="list-group-item list-group-item-action"
                        onClick={() => {
                            aemInvalidateCache();
                        }}
                    >
                        Invalidate Cache
                    </button>
                )}
            </div>
        </>
    );
}

export default NavList;
